export default "__VITE_ASSET__CmzF9N7r__"